import { render } from "./convention.vue?vue&type=template&id=07418ca4&scoped=true"
const script = {}

import "./convention.vue?vue&type=style&index=0&id=07418ca4&scoped=true&lang=less"

import exportComponent from "/Users/jizhengliang/Desktop/octopus/edu/educms-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07418ca4"]])

export default __exports__